module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Readers love")]), _vm._v(" "), _c('span', {
    staticClass: "t2"
  }, [_vm._v("Shadows in the Night")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("by")]), _vm._v(" "), _c('span', {
    staticClass: "t3"
  }, [_vm._v("M.A. C")]), _c('span', {
    staticClass: "t4"
  }, [_vm._v("HURCH")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('img', {
    attrs: {
      "alt": "img1.jpg",
      "height": "300",
      "src": "Images/img1.jpg",
      "width": "200"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("“The author’s writing style is a little quirky, but solid, clean, and straightforward, with a unique and original twist on the usual shifter tale. I enjoyed reading the book…”")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("—Mrs. Condit & Friends Read Books")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("“Ms. Church… is able to give the readers a refreshing look at this genre with her story,")]), _vm._v(" "), _c('span', {
    staticClass: "t8"
  }, [_vm._v("Shadows in the Night")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(".”")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("—Top 2 Bottom Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("“M.A. Church brings some refreshing ideas into shifter lore with")]), _vm._v(" "), _c('span', {
    staticClass: "t8"
  }, [_vm._v("Shadows in the Night")]), _c('span', {
    staticClass: "t7"
  }, [_vm._v(". It made for some intriguing reading and great food for thought.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("—Sensual Reads")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47993f62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/002.vue
// module id = 57
// module chunks = 0